<template>
    <template v-if="updateHash">
        <Teleport v-for="item in itemsToRender" :to="item.containerSelector" :key="item.id">
            <CartItemCommentEditor
                :item="item.item"
                :disabled="cart.isUpdating"
                :isOperatorUser="identity.hasOperatorAccess"
                :areItemCommentsAllowed="cart.areItemCommentsAllowed"
            />
        </Teleport>
    </template>
</template>

<script setup lang="ts">
    import { appEvents } from "@/app/events/appEvents";
    import { useCartStore } from "@/data/stores/cart";
    import { useIdentityStore } from "@/data/stores/identity";
    import { computed, nextTick, ref } from "vue";

    import CartItemCommentEditor from "@/components/cart/CartItemCommentEditor.vue";

    const cart = useCartStore();
    const identity = useIdentityStore();

    const updateHash = ref<string | null>(null);

    const currentCartItems = computed(() => cart.currentCart?.items ?? []);
    const itemsToRender = computed(() =>
        currentCartItems.value.map((item) => {
            return {
                id: item.id,
                containerSelector: `#${updateHash.value} .comment-editor-container.cart-item-comment-${item.id}`,
                item: item,
            };
        })
    );

    appEvents.cartController.cartUpdated.add(async (cartUpdatedEventData) => {
        cart.setCurrentCart(null);
        updateHash.value = null;

        await nextTick();

        updateHash.value = cartUpdatedEventData.updateHash;
        cart.setCurrentCart(cartUpdatedEventData.cart);
    });
</script>

<style lang="scss"></style>
